import type { UseQueryOptions } from "@tanstack/react-query";
import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../api";
import urls from "../urls";
import type { Variant } from "../utils/backend-types";

export function variantByProjectQuery(projectId?: string) {
  return queryOptions<Variant>({
    queryKey: ["variants", { projectId }],
    queryFn: projectId ? () => fetchVariants(projectId) : skipToken,
    staleTime: 10000
  });
}

export function useVariantByProject(
  projectId?: string,
  options?: Partial<UseQueryOptions<Variant> | undefined>
) {
  return useQuery({
    ...variantByProjectQuery(projectId),
    ...options
  });
}

async function fetchVariants(projectId: string) {
  const response = await apiWithoutCamelization.get<Array<Variant>>(
    urls.apiWithoutCamelization.variantsByProject(projectId)
  );
  return response.data[0]; // projects always have one variant since we removed the analyzer
}
